import { cn } from "../../utils/classnames"
import { LeadScoreCategory } from "../../../types"
import { CATEGORY_CONFIG, CATEGORIES } from "./category-helpers"

export type AcknowledgedFilter = "new" | "reviewed" | "all"

interface Props {
  activeCategory: LeadScoreCategory | null
  onChange: (category: LeadScoreCategory | null) => void
  acknowledgedFilter: AcknowledgedFilter
  onAcknowledgedFilterChange: (filter: AcknowledgedFilter) => void
  unacknowledgedCount?: number
}

const ACKNOWLEDGED_TABS: { id: AcknowledgedFilter; label: string }[] = [
  { id: "new", label: "New" },
  { id: "reviewed", label: "Reviewed" },
  { id: "all", label: "All" }
]

const CategoryFilterBar = ({
  activeCategory,
  onChange,
  acknowledgedFilter,
  onAcknowledgedFilterChange,
  unacknowledgedCount
}: Props) => {
  const categoryTabs = [
    { id: null, label: "All" },
    ...CATEGORIES.map(c => ({
      id: c as LeadScoreCategory,
      label: CATEGORY_CONFIG[c].labelPlural
    }))
  ]

  return (
    <div className="flex flex-wrap items-center gap-4">
      {/* Acknowledged state filter — segmented control */}
      <div className="flex bg-neutral-50 rounded-lg p-0.5 border border-neutral-200">
        {ACKNOWLEDGED_TABS.map(tab => {
          const isActive = acknowledgedFilter === tab.id
          return (
            <button
              key={tab.id}
              onClick={() => onAcknowledgedFilterChange(tab.id)}
              className={cn(
                "px-3 py-1.5 text-sm font-medium rounded-md transition-all",
                isActive
                  ? "bg-white text-neutral-800 shadow-sm"
                  : "text-neutral-500 hover:text-neutral-700"
              )}
            >
              {tab.label}
              {tab.id === "new" &&
                unacknowledgedCount != null &&
                unacknowledgedCount > 0 && (
                  <span className="ml-1.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold rounded-full bg-primary-400 text-white">
                    {unacknowledgedCount}
                  </span>
                )}
            </button>
          )
        })}
      </div>

      {/* Divider */}
      <div className="h-6 w-px bg-neutral-200" />

      {/* Category filter pills */}
      <div className="flex flex-wrap gap-2">
        {categoryTabs.map(tab => {
          const isActive =
            tab.id === activeCategory ||
            (tab.id === null && activeCategory === null)
          const activeClass =
            tab.id === null
              ? "bg-primary-100 border-primary-400 text-primary-600"
              : CATEGORY_CONFIG[tab.id].pillActiveClass

          return (
            <button
              key={tab.id ?? "all"}
              onClick={() => onChange(tab.id)}
              className={cn(
                "px-4 py-1.5 border rounded-full text-sm font-medium transition-all cursor-pointer",
                isActive
                  ? activeClass
                  : "border-neutral-200 text-neutral-500 hover:border-neutral-400"
              )}
            >
              {tab.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default CategoryFilterBar
